/**
 * セレクト要素の値が空かどうかをチェックし、data-no-value属性を設定する
 */
const checkEmptyValue = (selectElement) => {
    if (selectElement.value === "") {
        selectElement.setAttribute("data-no-value", "");
    } else {
        selectElement.removeAttribute("data-no-value");
    }
};

/**
 * セレクト要素の初期状態をチェックし、変更イベントリスナーを設定する
 */
const setupSelectElement = (select) => {
    // 初期状態をチェック
    checkEmptyValue(select);

    // 変更イベントをリッスン
    select.addEventListener("change", () => {
        checkEmptyValue(select);
    });
};

const main = () => {
    if (document.querySelector(".c-forms-select") === null) return;
    const targets = document.querySelectorAll(".c-forms-select select");
    targets.forEach((target) => {
        setupSelectElement(target);
    });
};

export default main;
